<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild " :class="roll ? 'down' : 'top'">
    <!--  :class="roll ? 'fadeOutDown' : 'fadeOutUp'" -->
    <!-- 电脑导航 -->
    <div class="container " style="display: flex;justify-content: space-between;">
      <div class="header-nav  hidden-xs  ">
        <!-- 导航logo -->

        <div class="header-nav-logo">
          <el-image :src="logo" />
        </div>
        <!-- 导航内容 -->
        <ul class="header-nav-wrapper">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)">
            <router-link :to="item.path">
              {{ item.name }}
              <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
              <i class="underline"></i>
            </router-link>
            <dl v-if="item.children.length > 0">
              <dt v-for="(i, n) in item.children" :key="n">
                <router-link :to="i.path">{{ i.name }}</router-link>
              </dt>
            </dl>
          </li>
        </ul>
      </div>
      <div class="nav-bt-box">
        <el-button @click="software">登录</el-button>
        <el-button type="primary" @click="register">免费使用</el-button>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo_black.png" alt="logo" />
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)" data-toggle="collapse" data-target="#menu">
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      logo: require("@/assets/img/yun_logo.png"),
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "产品下载",
          path: "/product",
          children: [
            //   {
            //     name: "品为云",
            //     path: "/software/smartTown"
            //   },
            //   {
            //     name: "排班签到",
            //     path: "/software/smartTown"
            //   },
            //   {
            //     name: "商机项目",
            //     path: "/software/smartTown"
            //   },
            //   {
            //     name: "计收支",
            //     path: "/software/smartTown"
            //   },
            //   {
            //     name: "临工管理",
            //     path: "/software/smartTown"
            //   },
            //   {
            //     name: "视同运维",
            //     path: "/software/smartTown"
            //   },
            //   {
            //     name: "绩效考核",
            //     path: "/software/smartTown"
            //   },
          ]
        },
        {
          name: "案例",
          path: "/software",
          children: []
        },
        // {
        //   name: "方案",
        //   path: "/service",
        //   children: []
        // },
        // {
        //   name: "服务",
        //   path: "/newsinformation",
        //   children: []
        // },
        {
          name: "购买",
          path: "/companyintroduction",
          children: []
        },
        // {
        //   name: "生态伙伴",
        //   path: "/jobchance",
        //   children: []
        // },
        // {
        //   name: "关于",
        //   path: "/contactus",
        //   children: []
        // }
      ],

      roll: true,
      i: 0
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  watch: {},

  methods: {
    handleFree() {

    },
    software() {
      this.$router.push({
        name: "software"
      });
    },
    register() {
      this.$router.push({
        name: "register"
      });
    },

    handleScroll(e) {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var scroll = scrollTop - this.i;
      this.i = scrollTop;

      if (scroll < 0) {
        // console.log("up");
        this.roll = true;
      } else {
        // console.log("down");
        this.roll = false;
      }
    },

    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-bt-box {
  display: flex;
  align-items: center;
  gap: 24px;
}

.down {
  animation-name: down;
  animation-timing-function: linear;
  animation-duration: 0.7s;
  animation-fill-mode: forwards;
}

.top {
  animation-name: top;
  animation-timing-function: linear;
  animation-duration: 0.7s;
  animation-fill-mode: forwards;
}

@keyframes down {
  from {
    top: -80px;
  }

  to {
    top: 0px;
  }
}

@keyframes top {
  from {
    top: 0px;
  }

  to {
    top: -80px;
  }
}

/* 顶部 */
#header {
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  border-bottom: 1px solid #eee;
  background-color: #fff;
}

/* 导航栏 */
#header .header-nav {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  // border-bottom: 1px solid #eee;

  background-color: #fff;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  display: flex;
  align-items: center;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 95px;
  height: 45px;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 80px;

  margin: 0;
  max-width: 800px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  float: left;
  margin: 0 15px;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  color: #000;
  font-size: 15px;
  padding: 15px 0;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: relative;
  bottom: 17px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #3D6FFD;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover {
  color: #3D6FFD;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  color: #3D6FFD;
  text-decoration: none;
  border-bottom: 2px solid #3D6FFD;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 80vw;
  height: 400px;
  top: 80px;
  left: 10vw;
  z-index: 999999;
  /*  box-shadow: 0 0 3px 1px #ccc;*/
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 200px;
  padding: 10px;
  color: #333 !important;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  background: #ccc;
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue